<div class="c-page-content" id="divPageContent">
  <router-outlet></router-outlet>
</div>
